import { Theme } from '@mui/material';

export const sxScrollWrapper = {
  height: '100%',

  '.simplebar-content': {
    minHeight: '100%',
  },
};

export const customScrollbar = (theme: Theme) => ({
  '& .customScrollBar': {
    '&::-webkit-scrollbar': {
      width: '6px',
      height: '6px',
    },

    '&::-webkit-scrollbar-track': {
      backgroundColor: theme.palette.grey[800],
    },

    '&::-webkit-scrollbar-thumb': {
      backgroundColor: theme.palette.grey[700],
      borderRadius: '12px',
    },
  },
});
